import * as $ from 'jquery';

export function onLoad(element)
{
    $(element).find('[data-schedule-payments-rejection]').each(function() {
        let container = this;
        $(this).find('button').click(() => {
            const rejectionParameters = $(this).data('schedule-payments-rejection');
            container.classList.add('loader');
            $.post({
                url: rejectionParameters.url,
                data: JSON.stringify({
                    _csrf_token: rejectionParameters.csrf_token
                }),
            }).then(response => {
                if (response.success && response.content) {
                    container.replaceChildren($(response.content)[0]);
                } else if (response.content) {
                    $(container).find('.js-error-container').html($(response.content));
                }
                container.classList.remove('loader');
                window.appOnLoadDom(container);
            }).catch(error => console.log(error));
        })
    });
}
